(function () {
  function getSectionId(pfc) {
    return pfc?.dataset?.sectionId || '';
  }

  function findVariantPickerForSection(sectionId) {
    if (!sectionId) return null;
    return document.querySelector(
      `variant-picker[data-section-id="${CSS.escape(sectionId)}"]`
    );
  }

  function getCheckedRadio(picker) {
    if (!picker) return null;
    return picker.querySelector('input[type="radio"][data-variant-id]:checked');
  }

  function extractFreeGramsFromCheckedLabel(checkedRadio) {
    if (!checkedRadio) return 0;

    // Le badge "+X g offerts" est dans le label parent
    const label = checkedRadio.closest('label');
    if (!label) return 0;

    const badge = label.querySelector(
      '.custom-variant-label__badge-right .custom-variant-badge'
    );
    const txt = (badge?.textContent || '').toLowerCase();

    const m = txt.match(/\+?\s*([0-9]+)\s*g/);
    if (!m) return 0;

    const n = Number(m[1]);
    return Number.isFinite(n) ? n : 0;
  }

  function setHiddenProperty(form, freeGrams) {
    const input = form.querySelector('[data-offer-free-grams]');
    if (!input) return;
    input.value = freeGrams > 0 ? `${freeGrams}g` : '';
  }

  function updateForProductFormComponent(pfc) {
    const sectionId = getSectionId(pfc);
    const picker = findVariantPickerForSection(sectionId);
    const checked = getCheckedRadio(picker);

    const form = pfc.querySelector(
      'form[action="/cart/add"], form[action*="/cart/add"]'
    );
    if (!form) return;

    const free = extractFreeGramsFromCheckedLabel(checked);
    setHiddenProperty(form, free);
  }

  function bind(pfc) {
    // Update initial
    updateForProductFormComponent(pfc);

    // Update on picker change (PDP / quand le picker n'est pas re-rendu)
    const sectionId = getSectionId(pfc);
    const picker = findVariantPickerForSection(sectionId);

    // 2026-02-01 (conservé)
    if (picker) {
      picker.addEventListener('change', () => {
        requestAnimationFrame(() => {
          updateForProductFormComponent(pfc);
        });
      });
    }

    // Filet de sécurité : au submit, on recalcule encore une fois
    const form = pfc.querySelector(
      'form[action="/cart/add"], form[action*="/cart/add"]'
    );
    if (form) {
      form.addEventListener(
        'submit',
        () => updateForProductFormComponent(pfc),
        { capture: true }
      );
    }
  }

  // -----------------------------
  // bind "once" + late binding
  // -----------------------------
  function bindOnce(pfc) {
    if (!pfc || pfc.dataset.offerFreeGramsBound === '1') return;
    pfc.dataset.offerFreeGramsBound = '1';
    bind(pfc);
  }

  function bindAll(root = document) {
    root.querySelectorAll('product-form-component').forEach(bindOnce);
  }

  document.addEventListener('DOMContentLoaded', () => {
    // 1) bind immédiat
    bindAll();

    // -------------------------------------------------------
    // NEW: listeners délégués (robustes aux re-render Shopify)
    // -------------------------------------------------------

    // A) Quand une radio variante change, même après re-render,
    // on recalcule pour la section correspondante.
    document.addEventListener(
      'change',
      (e) => {
        const radio = e.target?.closest?.(
          'input[type="radio"][data-variant-id]'
        );
        if (!radio) return;

        const picker = radio.closest('variant-picker');
        const sectionId = picker?.dataset?.sectionId;
        if (!sectionId) return;

        const pfc = document.querySelector(
          `product-form-component[data-section-id="${CSS.escape(sectionId)}"]`
        );
        if (!pfc) return;

        requestAnimationFrame(() => updateForProductFormComponent(pfc));
      },
      true
    );

    // B) Filet de sécurité : au clic sur ATC, on recalcule
    // (utile si l'ajout se fait sans submit classique)
    document.addEventListener(
      'click',
      (e) => {
        const btn = e.target?.closest?.(
          'button[type="submit"], button[name="add"]'
        );
        if (!btn) return;

        const form = btn.closest(
          'form[action="/cart/add"], form[action*="/cart/add"]'
        );
        if (!form) return;

        const pfc = form.closest('product-form-component');
        if (!pfc) return;

        requestAnimationFrame(() => updateForProductFormComponent(pfc));
      },
      true
    );

    // 2) re-bind quand Shopify recharge une section (éditeur / sections)
    document.addEventListener('shopify:section:load', (e) => {
      if (e?.target) bindAll(e.target);
    });

    // 3) fallback: bind si le composant arrive après coup (home/lazy/etc.)
    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches?.('product-form-component')) {
            bindOnce(node);
          } else if (node.querySelectorAll) {
            node
              .querySelectorAll('product-form-component')
              .forEach(bindOnce);
          }
        }
      }
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });
  });
})();
